import 'intersection-observer'
import React, { useEffect, useRef, useState } from 'react'
import classes from './Image.module.css'
import classNames from 'classnames'
import ContentLoader from 'react-content-loader'
import brokenImage from '../../assets/images/broken-image.png'

const Image = ({
    src,
    width,
    height,
    className = '',
    alt,
    lazyLoad = true,
    observerOptions = {},
    errorImageUrl = brokenImage,
    ...props
}) => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    const imageRef = useRef()

    useEffect(() => {
        const intersectionObserver = new IntersectionObserver(
            entries => {
                //If image is already loaded don't do this again
                if (!loading && imageRef.current) {
                    intersectionObserver.unobserve(imageRef.current)
                    return
                }

                const intersected = entries.find(
                    ({ isIntersecting }) => isIntersecting
                )

                if (intersected) {
                    setupImage()
                }
            },
            {
                root: null,
                threshold: 0.2,
                rootMargin: '0px',
                ...observerOptions,
            }
        )

        if (imageRef.current) {
            if (!lazyLoad) {
                setupImage()
            } else {
                intersectionObserver.observe(imageRef.current)
            }
        }

        return () => {
            intersectionObserver.disconnect()
        }
    }, [imageRef.current])

    const setupImage = () => {
        const image = imageRef.current

        image.addEventListener('load', () => {
            setLoading(false)
        })

        image.addEventListener('error', () => {
            setLoading(false)
            setError(true)
        })

        image.src = src
    }

    return (
        <div
            className={classNames(classes.imageWrapper, className)}
            style={{ width, minHeight: height }}
        >
            <ContentLoader
                className={classNames(
                    classes.imageLoader,
                    !loading && classes.imageLoaderHide
                )}
            >
                <rect width={'100%'} height={'100%'} />
            </ContentLoader>
            {!error && (
                <img
                    src=""
                    alt={alt}
                    ref={imageRef}
                    {...props}
                    className={classNames(
                        classes.image,
                        !loading && classes.imageShow,
                        className
                    )}
                />
            )}
            <img
                src={errorImageUrl}
                alt="Image failed to load"
                className={classNames(
                    classes.errorImage,
                    error && classes.errorImageShow
                )}
            />
        </div>
    )
}

export default Image
